import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import loginReducer from "./loginSlice";
import commonReducer from "./common/CommonSlice";
import countryReducer from "./common/CountrySlice";
import regionReducer from "./common/RegionSlice";
import stateReducer from "./common/StateSlice";
import areaReducer from "./common/AreaSlice";
import subAreaReducer from "./common/SubAreaSlice";
import schoolReducer from "./common/SchoolSlice";
import courseReducer from "./common/CourseSlice";
import courseLevelReducer from "./common/CourseLevelSlice";
import lookupReducer from "./common/LookupSlice";
import forgetPasswordReducer from "./forgetPasswordSlice";

const loginPersist = {
  key: "loginData",
  storage,
};
const countryPersist = {
  key: "countryData",
  storage,
};
const regionPersist = {
  key: "regionData",
  storage,
};
const statePersist = {
  key: "stateData",
  storage,
};
const areaPersist = {
  key: "areaData",
  storage,
};
const subAreaPersist = {
  key: "subAreaData",
  storage,
};
const schoolPersist = {
  key: "schoolData",
  storage,
};
const coursePersist = {
  key: "courseData",
  storage,
};
const courseLevelPersist = {
  key: "courseLevelData",
  storage,
};
const lookupPersist = {
  key: "lookupData",
  storage,
};

export const store = configureStore<any>({
  reducer: {
    // our reducers goes here
    // login: loginReducer,
    login: persistReducer(loginPersist, loginReducer),
    /* This is kept for future reference */
    // user: userReducer,
    forgetPassword: forgetPasswordReducer,
    common: commonReducer,
    country: persistReducer(countryPersist, countryReducer),
    region: persistReducer(regionPersist, regionReducer),
    state: persistReducer(statePersist, stateReducer),
    area: persistReducer(areaPersist, areaReducer),
    subArea: persistReducer(subAreaPersist, subAreaReducer),
    school: persistReducer(schoolPersist, schoolReducer),
    course: persistReducer(coursePersist, courseReducer),
    courseLevel: persistReducer(courseLevelPersist, courseLevelReducer),
    lookup: persistReducer(lookupPersist, lookupReducer),
    // report: ReportReducer,
    // order: orderReducer,
  },
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action<string>
>;
